import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconButton, Tooltip } from '@material-ui/core';
import SettingsIcon from '@material-ui/icons/SettingsSharp';
import { defineMessages, FormattedMessage } from 'react-intl';

import * as actions from '../../../../state';
import { BoardSettingsDialog } from '../../../dialogs';
import { selectLayout } from '../../../../state';

const messages = defineMessages({
  BOARD_SETTINGS: {
    id: 'BOARD_SETTINGS',
    defaultMessage: 'Board settings',
  },
});

function BoardSettingsBtn() {
  const dispatch = useDispatch();

  const layout = useSelector(selectLayout);

  return (
    <>
      <Tooltip disableFocusListener title={<FormattedMessage {...messages.BOARD_SETTINGS} />}>
        <IconButton onClick={() => dispatch(actions.showBoardSettingsDialog(!layout.showBoardSettingsDialog))}>
          <SettingsIcon />
        </IconButton>
      </Tooltip>

      <BoardSettingsDialog />
    </>
  );
}

export default BoardSettingsBtn;
